import { render, staticRenderFns } from "./EmergencyOrderContainerStatusChip.vue?vue&type=template&id=2c543562"
import script from "./EmergencyOrderContainerStatusChip.vue?vue&type=script&lang=js"
export * from "./EmergencyOrderContainerStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports